import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { DATA_INTER } from './constant';
import { ModalPopup, POPUP_MODAL_DATA } from '../../data/popup/frame/modal';

export const Component: React.FC<{
  data?: DATA_INTER;
  isLoading?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  errorMessage?: string;
}> = ({ data, isLoading, isSuccess, isError, errorMessage }) => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const [isModalOpen, setModalOpen] = useState<boolean>(false);

  useEffect(() => {
    if (data && !data.isEmpty && data.list && data.list.length > 0) {
      setCurrentIndex(0);
      setModalOpen(true);
    } else {
    }
  }, [data]);

  const handleCloseModal = () => {
    if (data && data.list && currentIndex < data.list.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setModalOpen(false);
    }
  };
  return (
    <Container>
      {isLoading && <></>}
      {data?.isEmpty && !isLoading && <></>}
      {!isLoading && <></>}
      {isSuccess && data && !data.isEmpty && data.list && isModalOpen && (
        <>
          {data.list[currentIndex] && (
            <ModalPopup
              isOpen={isModalOpen}
              onClose={handleCloseModal}
              data={data.list[currentIndex] as POPUP_MODAL_DATA}
            />
          )}
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;
